import { render, staticRenderFns } from "./TableCarNumber.vue?vue&type=template&id=1080283a"
import script from "./TableCarNumber.vue?vue&type=script&lang=js"
export * from "./TableCarNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports